import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { LendioResponse } from 'app/models/lendio-response';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DecisioningService {

    constructor(
        private httpClient: ApiHttpClient,
    ) {
    }

    /**
     * @param borrowerId 
     * @param loanProductId 
     * @return LendioResponse
     */
    queueBorrowerDecisioning(borrowerId: number, loanProductId: number): Observable<LendioResponse> {
        return this.httpClient.post<LendioResponse>(
            `${environment.API_URL}/borrower/${borrowerId}/queue-decisioning?loanProductId=${loanProductId}`, {}
        );
    }
}